import React from "react";
import { useLang } from "@/lib/i18n";

export default function LanguageSwitcher({ variant = "dark" }) {
  const { lang, setLang } = useLang();
  const isLight = variant === "light"; // for transparent nav over hero
  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center rounded-full p-0.5 border ${
        isLight ? "border-white/30 bg-white/10 backdrop-blur-sm" : "border-slate-200 bg-white"
      }`}
    >
      {["de", "en"].map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            data-testid={`lang-${code}`}
            onClick={() => setLang(code)}
            className={`px-3 py-1 text-xs font-semibold uppercase tracking-[0.15em] rounded-full transition-all duration-200 ${
              active
                ? isLight
                  ? "bg-white text-[#0A192F]"
                  : "bg-[#0A192F] text-white"
                : isLight
                ? "text-white/80 hover:text-white"
                : "text-slate-500 hover:text-[#0A192F]"
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
}
